import { render, staticRenderFns } from "./wangEditor.vue?vue&type=template&id=c1ee1140&scoped=true&"
import script from "./wangEditor.vue?vue&type=script&lang=js&"
export * from "./wangEditor.vue?vue&type=script&lang=js&"
import style0 from "./wangEditor.vue?vue&type=style&index=0&id=c1ee1140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ee1140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1ee1140')) {
      api.createRecord('c1ee1140', component.options)
    } else {
      api.reload('c1ee1140', component.options)
    }
    module.hot.accept("./wangEditor.vue?vue&type=template&id=c1ee1140&scoped=true&", function () {
      api.rerender('c1ee1140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wangEditor.vue"
export default component.exports